import { AlertCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface EnvErrorScreenProps {
  error: Error;
}

export function EnvErrorScreen({ error }: EnvErrorScreenProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-lg border-destructive/50">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
              <AlertCircle className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-2xl">Ошибка конфигурации</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">
            Приложение не может запуститься из-за отсутствующих переменных окружения.
          </p>
          <div className="bg-muted p-4 rounded-lg">
            <p className="font-semibold text-sm mb-2">Детали ошибки:</p>
            <pre className="text-xs overflow-auto text-destructive whitespace-pre-wrap">
              {error.message}
            </pre>
          </div>
          <div className="bg-blue-50 dark:bg-blue-950 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
            <p className="font-semibold text-sm mb-2 text-blue-900 dark:text-blue-100">
              Как исправить:
            </p>
            <ol className="text-xs text-blue-800 dark:text-blue-200 space-y-1 list-decimal list-inside">
              <li>Убедитесь, что файл .env существует в корне проекта</li>
              <li>Проверьте наличие всех необходимых переменных VITE_*</li>
              <li>Перезапустите сервер разработки после изменения .env</li>
            </ol>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
